import React from 'react'

const KUPER_RABOTA = 'https://kuper.ru/rabota'

function KuperLink ({ text = 'на сайте' }) {
  return (
    <a href={KUPER_RABOTA} target='_blank' rel='noreferrer'>
      {text}
    </a>
  )
}

export default KuperLink
